const s = (n, t) => `${n}--${t}`, i = (n, t, o) => typeof o == "string" ? o.split(" ").map((e) => s(n, `${t}${e}`)).join(" ") : s(n, t), r = (n, t, o) => typeof t == "boolean" ? t ? s(n, o) : "" : i(n, o, t);
export {
  r as buildBooleanClass,
  s as modifyClassName,
  i as responsiveModifyClass
};
